<template>
  <v-container  v-if="resume.educations.length > 0" class="py-2">
    <BaseDivider :title="this.$t('educations')" />
    <div class="mb-1" v-for="(education, i) in resume.educations" :key="i">
      <template>
        <h4>
          {{ education.field }}
        </h4>
        <p class="school">
          {{ education.school }} | {{ $t("from") }} {{ education.startDate }} {{ $t("to") }}
          {{ education.present ? $t("present"): education.endDate }}
        </p>
      </template>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "pinia";
import { useCreateResumeStore } from "@/modules/create_resume/store/CreateResumeStore";
import BaseDivider from "./BaseDivider.vue";
export default {
    computed: {
        ...mapState(useCreateResumeStore, ["resume", "selectedColor"]),
    },
    components: { BaseDivider }
};
</script>

<style scoped>
.school {
  opacity: 0.8;
}
</style>
